(function() {
    'use strict';

    var BLOCKED_GIFT_IDS_ATTRIBUTE = 'free_gift_blocked_ids';
    var DEFAULT_BANNER_TEXT_ATTRIBUTE = 'gift-removed-banner-text';
    var bannerTimeout = null;
    var bannerActive = false;
    var bannerTextAttribute = DEFAULT_BANNER_TEXT_ATTRIBUTE;

    function parseIdList(value) {
        if (!value) return [];

        return value.split(',').map(function(item) {
            return item.trim();
        }).filter(function(item) {
            return item !== '';
        });
    }

    function serializeBlockedGiftIds(ids) {
        return ids.filter(function(id, index, array) {
            return id && array.indexOf(id) === index;
        }).join(',');
    }

    function getBlockedGiftIds(cart) {
        if (!cart || !cart.attributes) return [];

        return parseIdList(cart.attributes[BLOCKED_GIFT_IDS_ATTRIBUTE]);
    }

    function refreshCartState() {
        if (window.location.pathname.indexOf('/cart') !== -1) {
            window.location.reload();
            return;
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    function showGiftRemovedBanner(bar, textAttribute) {
        bannerActive = true;
        bannerTextAttribute = textAttribute || DEFAULT_BANNER_TEXT_ATTRIBUTE;
        applyBannerState(bar);
        if (bannerTimeout) clearTimeout(bannerTimeout);
        bannerTimeout = setTimeout(function() { hideGiftRemovedBanner(); }, 3000);
    }

    function hideGiftRemovedBanner() {
        bannerActive = false;
        if (bannerTimeout) { clearTimeout(bannerTimeout); bannerTimeout = null; }
        var banners = document.querySelectorAll(".gamification-bar__banner");
        banners.forEach(function(banner) {
            banner.setAttribute("hidden", "");
        });
    }

    function applyBannerState(bar) {
        if (!bar) return;
        var banner = bar.querySelector(".gamification-bar__banner");
        if (!banner) return;
        if (bannerActive) {
            var text = bar.getAttribute(bannerTextAttribute) || bar.getAttribute(DEFAULT_BANNER_TEXT_ATTRIBUTE);
            if (!text) return;
            banner.querySelector(".gamification-bar__banner-text").textContent = text;
            banner.removeAttribute("hidden");
        } else {
            banner.setAttribute("hidden", "");
        }
    }

    var handleGamification = function() {
        var bars = document.querySelectorAll("gamification-bar");
        if (!bars.length) return;

        var bar = bars[0];

        var cartAmount = Number(bar.getAttribute("total-price"));
        var highestThreshold = Number(bar.getAttribute("highest-threshold")) || 1;
        var thresholds = [];
        var sortedThresholds = [];

        Array.from(bar.attributes).forEach(function(attr) {
            if (attr.name.startsWith("threshold-")) {
                thresholds.push(parseFloat(attr.value));
            }
        });
        sortedThresholds = thresholds.slice().sort(function(a, b) { return a - b; });

        if (sortedThresholds.length === 0) return;

        var indexInSortedThresholds;

        if (cartAmount < sortedThresholds[0]) {
            indexInSortedThresholds = 0;
        } else if (cartAmount >= sortedThresholds[sortedThresholds.length - 1]) {
            indexInSortedThresholds = sortedThresholds.length - 1;
        } else {
            for (var i = 0; i < sortedThresholds.length; i++) {
                if (cartAmount >= sortedThresholds[i] && cartAmount < sortedThresholds[i + 1]) {
                    indexInSortedThresholds = i;
                    break;
                }
            }
        }

        function formatPrice(price) {
            return (price / 100).toFixed(2).toString().replace('.', ',') + ' €';
        }

        var progress = Math.min(cartAmount / highestThreshold, 1);
        var amountToNextThreshold = 0;

        if (cartAmount >= sortedThresholds[sortedThresholds.length - 1]) {
            amountToNextThreshold = 0;
        } else if (cartAmount < sortedThresholds[0]) {
            amountToNextThreshold = sortedThresholds[0] - cartAmount;
        } else {
            amountToNextThreshold = sortedThresholds[indexInSortedThresholds + 1] - cartAmount;
        }

        bars.forEach(function(currentBar) {
            var progressBar = currentBar.querySelector(".progress-bar");
            if (progressBar) {
                progressBar.style.setProperty('--progress', progress);
            }

            var markers = currentBar.querySelectorAll(".gamification-bar__marker");
            markers.forEach(function(marker) {
                var markerThreshold = Number(marker.getAttribute("data-threshold"));
                if (cartAmount >= markerThreshold) {
                    marker.classList.add("gamification-bar__marker--reached");
                } else {
                    marker.classList.remove("gamification-bar__marker--reached");
                }
            });

            var messageElement = currentBar.querySelector(".gamification-bar__message");
            if (!messageElement) return;

            if (cartAmount >= sortedThresholds[sortedThresholds.length - 1]) {
                messageElement.innerHTML = currentBar.getAttribute("reached-message");
            } else if (cartAmount < sortedThresholds[0]) {
                var settingsUnreached = currentBar.getAttribute("settings-message-unreached");
                if (settingsUnreached) {
                    messageElement.innerHTML = settingsUnreached.replace("remaining_amount", formatPrice(amountToNextThreshold));
                } else {
                    var msg = currentBar.getAttribute('message-' + thresholds.indexOf(sortedThresholds[0]));
                    messageElement.innerHTML = msg ? msg.replace("remaining_amount", formatPrice(amountToNextThreshold)) : '';
                }
            } else {
                var settingsShippingReached = currentBar.getAttribute("settings-message-shipping-reached");
                if (settingsShippingReached) {
                    messageElement.innerHTML = settingsShippingReached.replace("remaining_amount", formatPrice(amountToNextThreshold));
                } else {
                    var msg2 = currentBar.getAttribute('message-' + thresholds.indexOf(sortedThresholds[indexInSortedThresholds + 1]));
                    messageElement.innerHTML = msg2 ? msg2.replace("remaining_amount", formatPrice(amountToNextThreshold)) : '';
                }
            }

            applyBannerState(currentBar);
        });

        fetch(Shopify.routes.root + 'cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
                var blockedGiftIds = getBlockedGiftIds(cart);
                var unavailableGiftIds = parseIdList(bar.getAttribute("unavailable-gift-ids"));
                var nextBlockedGiftIds = blockedGiftIds.slice();
                var arrayFreeGiftAdd = [];
                var arrayFreeGiftRemove = [];

                sortedThresholds.forEach(function(threshold) {
                    var freeGiftIds = parseIdList(bar.getAttribute('free-gift-' + thresholds.indexOf(threshold)));
                    freeGiftIds.forEach(function(freeGiftId) {
                        if (threshold <= cartAmount && !blockedGiftIds.includes(freeGiftId) && !unavailableGiftIds.includes(freeGiftId)) {
                            arrayFreeGiftAdd.push(freeGiftId);
                        }
                        if (threshold > cartAmount) {
                            arrayFreeGiftRemove.push(freeGiftId);
                            if (nextBlockedGiftIds.includes(freeGiftId)) {
                                nextBlockedGiftIds.splice(nextBlockedGiftIds.indexOf(freeGiftId), 1);
                            }
                        }
                    });
                });

                var itemsAdd = [];
                if (arrayFreeGiftAdd.length > 0) {
                    arrayFreeGiftAdd.forEach(function(item) {
                        var isInCart = cart.items.some(function(cartItem) {
                            return cartItem.id === Number(item) && cartItem.properties && cartItem.properties._free_gift === "true";
                        });
                        if (item && item !== 'ship' && Number(item) > 0 && !isInCart) {
                            itemsAdd.push({
                                'id': Number(item),
                                'quantity': 1,
                                'properties': { '_free_gift': 'true' }
                            });
                        }
                    });
                }

                var updates = {};
                if (arrayFreeGiftRemove.length > 0) {
                    arrayFreeGiftRemove.forEach(function(item) {
                        var isInCart = cart.items.find(function(cartItem) {
                            return cartItem.id === Number(item) && cartItem.properties && cartItem.properties._free_gift === "true";
                        });
                        if (item !== 'ship' && isInCart) {
                            updates[isInCart.key] = 0;
                        }
                    });
                }

                var hasBlockedGiftIdChanges = serializeBlockedGiftIds(blockedGiftIds) !== serializeBlockedGiftIds(nextBlockedGiftIds);
                var hasGiftUpdates = Object.keys(updates).length > 0;

                if (hasBlockedGiftIdChanges || hasGiftUpdates || itemsAdd.length > 0) {
                    var addPromise = Promise.resolve();

                    if (itemsAdd.length > 0) {
                        addPromise = fetch(Shopify.routes.root + 'cart/add.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: JSON.stringify({ 'items': itemsAdd })
                        });
                    }

                    addPromise.then(function() {
                        if (!hasBlockedGiftIdChanges && !hasGiftUpdates) {
                            return;
                        }

                        return fetch(Shopify.routes.root + 'cart/update.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: JSON.stringify({
                                updates: updates,
                                attributes: (function() {
                                    var attributes = {};
                                    attributes[BLOCKED_GIFT_IDS_ATTRIBUTE] = serializeBlockedGiftIds(nextBlockedGiftIds);
                                    return attributes;
                                })()
                            })
                        }).then(function() {
                            if (hasGiftUpdates) {
                                showGiftRemovedBanner(bar);
                            }
                        });
                    }).then(function() {
                        refreshCartState();
                    });
                }
            });
    };

    // The gift can already be in an open cart when the merchant's limit runs out. Nothing else removes it:
    // the bar stops emitting the gift threshold, so handleGamification never sees the line, and the Cart
    // Transform Function keeps pricing it at zero. Resolves true when it changed the cart.
    function handleExhaustedGift() {
        var bar = document.querySelector("gamification-bar[exhausted-gift-id]");
        if (!bar) return Promise.resolve(false);

        var exhaustedGiftIds = parseIdList(bar.getAttribute("exhausted-gift-id"));
        if (!exhaustedGiftIds.length) return Promise.resolve(false);

        return fetch(Shopify.routes.root + 'cart.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
                var updates = {};

                cart.items.forEach(function(cartItem) {
                    if (exhaustedGiftIds.includes(String(cartItem.id)) && cartItem.properties && cartItem.properties._free_gift === "true") {
                        updates[cartItem.key] = 0;
                    }
                });

                if (Object.keys(updates).length === 0) return false;

                return fetch(Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    body: JSON.stringify({ updates: updates })
                }).then(function(response) {
                    // Refreshing on a failed update would re-enter this pass with the line still there.
                    if (!response.ok) return false;

                    showGiftRemovedBanner(bar, 'gift-limit-banner-text');
                    refreshCartState();
                    return true;
                });
            })
            .catch(function() { return false; });
    }

    function handleRemoveFreeGift() {
        var removeFreeGift = document.querySelectorAll(".js-remove-free-gift");
        removeFreeGift.forEach(function(item) {
            item.addEventListener("click", function(event) {
                event.preventDefault();
                var dataId = event.currentTarget.getAttribute("data-id");
                var lineKey = event.currentTarget.getAttribute("data-line-key");

                fetch(Shopify.routes.root + 'cart.js')
                .then(function(response) { return response.json(); })
                .then(function(cart) {
                    var blockedGiftIds = getBlockedGiftIds(cart);

                    if (!blockedGiftIds.includes(dataId)) {
                        blockedGiftIds.push(dataId);
                    }

                    return fetch(Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: JSON.stringify({
                            updates: {
                                [lineKey]: 0
                            },
                            attributes: {
                                free_gift_blocked_ids: serializeBlockedGiftIds(blockedGiftIds)
                            }
                        })
                    });
                })
                .then(function() {
                    refreshCartState();
                });
            });
        });
    }

    ["DOMContentLoaded", "run:gamification"].forEach(function(e) {
        document.addEventListener(e, function() {
            // Serialised: both write the cart, and a removal already triggers a re-render that runs this again.
            handleExhaustedGift().then(function(cartChanged) {
                if (!cartChanged) handleGamification();
            });
            handleRemoveFreeGift();
        });
    });

    document.addEventListener("dialog:after-hide", function(event) {
        if (event.target.tagName && event.target.tagName.toLowerCase() === "cart-drawer") {
            hideGiftRemovedBanner();
        }
    });
})();
